<template>
    <!-------------------------------------------------------- Header propale ----------------------------------------------------------------->
    <div class="headerPropale">
    <!----------------------------------------------------- Infos du Tiers ----------------------------------------------->
        <div class="infosTiers">
            <p>Tiers : <a :href="'/detailsTiers/'+infosTiers.id">{{ infosTiers.name }}</a></p>
            <p>Commande n° {{ propale.ref }} du {{ dateCreation }}</p>
            <p>Référence client : {{ propale.ref_client }}</p>
            <p>Affecté à : {{  }}</p>
            <p>Condition de règlement : 
              <el-select v-model="propale.cond_reglement_id" placeholder="Condition de règlement">
                <el-option
                  v-for="item in optionsPayment"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </p>
            <p>Mode de règlement :
              <el-select v-model="propale.mode_reglement_id" placeholder="Mode de règlement">
                <el-option
                  v-for="item in optionsConditionsPayment"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </p>
            <p>Commentaire : {{ }}</p>
        </div>
    <!--------------------------------------------- Récapitulatif de la propale ---------------------------------------------------------->
        <div class="recapPropale">
            <el-table
                :data="tableRecap"
                stripe
                style="width: 95%">
                <el-table-column
                prop="titleLine">
                </el-table-column>
                <el-table-column
                prop="total">
                </el-table-column>
                <el-table-column
                prop="marges"
                label="Marges">
                </el-table-column>
                <el-table-column
                prop="prixVente"
                label="Prix de vente">
                </el-table-column>
                <el-table-column
                prop="prixRevient"
                label="Prix de revient">
                </el-table-column>
                <el-table-column
                prop="marge"
                label="Marge">
                </el-table-column>
                <el-table-column
                prop="tauxMarque"
                label="Taux de marque">
                </el-table-column>
            </el-table>
        </div>
    <!------------------------------------------------------------ Fin Header ---------------------------------------------------------------->
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import fr from '../../../../../node_modules/vuejs-datepicker/dist/locale/translations/fr.js'
import script from '../../../../script/script.js'
import scriptTiers from '../../../../script/script_tiers.js'
import scriptPropale from '../../../../script/script_propale.js'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
var moment = require('moment');
function initialState (){
  return {
    fr: fr,
    isTiers: false,
    tiers: [],
    optionsModelPdf: [{value: 'azur', text: 'azur'}],
    optionsPayment: [],
    optionsConditionsPayment: [],
    optionsDeliveryDelay: [],
    optionsTiers: [],
    form: {
      refClient: '',
      socid: null,
      selectedDate: new Date(),
      selectedDeliveryDelay: null,
      selectedConditionsPayment: '14',
      selectedPayment: null,
      selectedModel: 'azur'
    },
    products: [],
    timeout: null,
    editorOption: {
      modules: {
        toolbar: '#toolbar'
      }
    },
    listAuthor:[],
  }
}
export default {
    props: [
        "socid",
        "idPropale"
    ],
  data () {
    return initialState()
  },
  methods: {
    resetData(){
      Object.assign(this.$data, initialState())
    },
    detailsTiers: scriptTiers.detailsTiers,
    loadingDictionary: scriptTiers.loadingDictionary,
    loadPropale: scriptPropale.loadPropale,
    loadingClient: scriptTiers.loadingClient,
    getModeReglement: scriptPropale.getModeReglement,
    getConditionReglement: scriptPropale.getConditionReglement,
    verifyTiers () {
      if(this.socid!=null){
        this.detailsTiers(this.socid)
        this.isTiers = true
        this.form.socid = this.socid
      }else{
        this.loadingClient()
      }
    },
    visualDevisTiers: scriptTiers.visualDevisTiers,
    convertNumber(x) {
      return Number.parseFloat(x).toFixed(2)
    },
  },
  watch: {
  },
  mounted: function () {
    this.verifyTiers()
    this.getModeReglement()
    this.getConditionReglement()
  },
  components: {
    draggable,
  },
  computed:{
    dateCreation(){
      return moment(this.propale.datec*1000).format('L')
    },
    dateModif(){
      return moment(this.propale.date_modification).format('L')
    },
    nameFile(){
      let reg=new RegExp("[/]+", "g")
      let tab = this.propale.last_main_doc.split(reg)
      return tab[2]
    },
    tableRecap(){
      let recap=[]
      if(this.propale){
        let globalPrixVente = 0
        let globalTotalHtProd = 0
        let globalTotalHaProd = 0
        let globalTotalHtServ = 0
        let globalTotalHaServ = 0
        let margeProd = 0
        let margeServ = 0
        let margeGlobale = 0
        let marqueProd = 0
        let marqueServ = 0
        let marqueGlobale = 0
        if(this.propale){
          this.propale.lines.forEach(line => {
            globalPrixVente += (this.convertNumber(line.pa_ht)*line.qty)
            if(line.fk_product_type == 0){
              globalTotalHtProd += parseFloat(line.total_ht)
              globalTotalHaProd += (this.convertNumber(line.pa_ht)*line.qty)
            }else if(line.fk_product_type == 1){
              globalTotalHtServ += parseFloat(line.total_ht)
              globalTotalHaServ += (this.convertNumber(line.pa_ht)*line.qty)
            }

            margeProd = this.convertNumber(globalTotalHtProd-globalTotalHaProd)
            if(globalTotalHtProd > 0){
              marqueProd = this.convertNumber((margeProd/globalTotalHtProd)*100)
            }

            margeServ = this.convertNumber(globalTotalHtServ-globalTotalHaServ)
            if(globalTotalHtServ > 0){
              marqueServ = this.convertNumber((margeServ/globalTotalHtServ)*100)
            }

            margeGlobale = this.convertNumber(this.propale.total_ht-globalPrixVente)
            if(this.propale.total_ht > 0){
              marqueGlobale = this.convertNumber((margeGlobale/this.propale.total_ht)*100)
            }
          })
          recap=[
            {
              titleLine:"Montant HT",
              total:this.convertNumber(this.propale.total_ht),
              marges:"Marge / Produits HT",
              prixVente:this.convertNumber(globalTotalHtProd),
              prixRevient:this.convertNumber(globalTotalHaProd),
              marge:margeProd,
              tauxMarque:marqueProd
            },
            {
              titleLine:"Montant TVA",
              total:this.convertNumber(this.propale.total_tva),
              marges:"Marge / Services HT",
              prixVente:this.convertNumber(globalTotalHtServ),
              prixRevient:globalTotalHaServ = this.convertNumber(globalTotalHaServ),
              marge:margeServ,
              tauxMarque:marqueServ
            },
            {
              titleLine:"Montant TTC",
              total:this.convertNumber(this.propale.total_ttc),
              marges:"Marge Totale HT",
              prixVente:this.convertNumber(this.propale.total_ht),
              prixRevient:this.convertNumber(globalPrixVente),
              marge:margeGlobale,
              tauxMarque:marqueGlobale
            }
          ]
        }
      }
      return recap
    },
    infosTiers(){
      return this.$store.state.infoSoc
    },
    propale(){
      return this.$store.state.currentPropale
    }
  }
}
</script>

<style scoped>
#infoDevis{
  flex: 1 1 45%;
  margin-right: 5%;
}

#infoProduit{
  flex: 1 1 45%;
}

#tableProduct >>> .descriptionProduct{
  width: 20em;
  max-width: 20em;
}

#tableProduct >>> .prixProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .tvaProduct{
  width: 6em;
  max-width: 6em;
}

#tableProduct >>> .qtyProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .reducProduct{
  width: 6em;
  max-width: 6em;
}

#selectType{
  margin-bottom: 1em;
}

#selectTypeLine{
  margin-bottom: 1em;
}

#formPropal{
  display: flex;
}

.actionBarPropal{
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: end;
  padding: 1em;
  background: white;
}

.headerPropale{
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.headerPropale p{
  margin: 0;
}

.infosTiers{
  flex: 0 0 25%;
}

.recapPropale{
  flex: 0 0 75%;
}

.statusPropale{
  flex: 0 0 10%;
  text-align: center;
}
</style>